import React, {useRef, useEffect} from 'react';
import NoSleep from '../../lib/noSleep';


const NoSleepContainer = () => {
    const noSleep = useRef();

    useEffect(()=>{
        noSleep.current = new NoSleep();

        document.addEventListener('click', function enableNoSleep() {
            document.removeEventListener('click', enableNoSleep, false);
            noSleep.current.enable();
          }, false);

        return () => {
            noSleep.current.disable();
            noSleep.current = null;
        }
    },[]);

    return null;
}

export default NoSleepContainer;